import React from 'react';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';


interface IConfirmDeleteModal {
    openModal: boolean;
    loading?: boolean;
    handleCloseModal: () => void;
    onApproveAction: () => void;
}

const ConfirmDeleteModal = ({
    openModal,
    loading,
    handleCloseModal,
    onApproveAction,
}: IConfirmDeleteModal) => {
    return (
        <Modal
            open={openModal}
            showInRight
            title={'Delete Purchase'}
            onClose={() => handleCloseModal()}
        >
            <div className={'p-2 min-w-[500px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Delete</p>
                </div>
                <div className='p-2 !rounded bg-[#f8f9fc]'>
                    <p className='mt-2 mb-5 text-[17px] font-medium'>Are you sure you want to delete this purchase?</p>
                    <div className='flex flex-row justify-around items-center mt-7 mb-3'>
                        <Button
                            label='No'
                            dataQa={'continue-button'}
                            className={`${loading ? 'btn-primary-disable' : 'btn-primary !border-0'} min-w-[150px]`}
                            onClickButton={() => !loading && handleCloseModal()}
                        />
                        <Button
                            label='Yes'
                            dataQa={'continue-button'}
                            className={`${loading ? 'btn-primary-disable !rounded' : 'btn-error'} min-w-[150px]`}
                            onClickButton={() => !loading && onApproveAction()}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export default ConfirmDeleteModal;